import { Link, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

const OpenSourceConnectorNotice: FunctionComponent<
  React.PropsWithChildren<OpenSourceConnectorNoticeProps>
> = ({ openSourceWebsite, connectorName, license, openSourceAuthor }) => {
  return (
    <div>
      <Typography variant='body2' component='div'>
        <u>{connectorName} is an open source tool</u>
        <div>Developed by: {openSourceAuthor || ''}.</div>
        <div>License: {license || ''}.</div>
        <div>
          Website:{' '}
          <Link href={openSourceWebsite || '#'} target='_blank'>
            {openSourceWebsite || ''}
          </Link>
        </div>
      </Typography>
    </div>
  );
};

interface OpenSourceConnectorNoticeProps {
  openSourceWebsite: string | undefined;
  connectorName: string;
  license: string | undefined;
  openSourceAuthor: string | undefined;
}

export default OpenSourceConnectorNotice;
